import * as React from "react";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FeedbackSettingsPreview from "./FeedbackSettingsPreview";
import BugSettingsPreview from "./BugSettingsPreview";
import FeatureRequestPreview from "./FeatureRequestPreview";
import WidgetPreview from "./WidgetPreview";
import { appLogger } from "../../../utils";
import MultiFeedbackSettingsPreview from "./MultiFeedbackSettingsPreview";
import {
  FEEDBACK_FLOW_DYNAMIC,
  FEEDBACK_TYPE_BUGS,
  FEEDBACK_TYPE_FEATURE_REQ,
  FEEDBACK_TYPE_FEEDBACK,
  TYPE_IMAGE,
  TYPE_TEXT,
} from "../../../model";

import FooterLogo from "./WebAgentPreview/FooterLogo";

import "./PreviewStyles/index.css";
import {
  enableFeedback,
  enableBugReport,
  enableFeatureRequest,
  uploadFileBucketName,
} from "../../../utils/config";

const renderChevronRight = ({
  width = "10px",
  height = "10px",
  color,
}: {
  width: string;
  height: string;
  color: string;
}) => {
  return (
    <Box>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 18 33"
        fill="none"
      >
        <path
          opacity="0.7"
          d="M16.7097 15.1483C17.4318 15.9048 17.4318 17.0952 16.7097 17.8517L2.71556 32.5123C2.41823 32.8238 2.00636 33 1.57574 33C0.705483 33 -3.08376e-08 32.2945 -6.88778e-08 31.4243L-7.35611e-08 31.3171C-9.24787e-08 30.8843 0.166733 30.4682 0.46556 30.1551L13.5 16.5L0.465558 2.84487C0.166731 2.53181 -1.35e-06 2.11567 -1.36891e-06 1.68288L-1.3736e-06 1.57574C-1.41164e-06 0.705482 0.705481 -3.08376e-08 1.57574 -6.88778e-08C2.00636 -8.77009e-08 2.41822 0.176235 2.71556 0.487728L16.7097 15.1483Z"
          fill={color}
        ></path>
      </svg>
    </Box>
  );
};

const GeneralSettingsAgentPreview = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "GeneralSettingsAgentPreview",
      component: "add-product",
      fileName: "GeneralSettingsAgentPreview.tsx",
      props: props,
    },
  });

  const { productParams, widgetInfo } = props;
  const [dense, setDense] = React.useState(false);
  const [secondary, setSecondary] = React.useState(false);
  const [Changeradiocat, setChangeradiocat] = React.useState("");

  const [PreviewZoom, setPreviewZoom] = React.useState<any>("zoomout");
  const [previewAgent, setPreviewAgent] = React.useState<boolean>(false);

  const [selectedCategory, setSelectedCategory] = React.useState<string>("");
  let userEnabledFeatures: any = localStorage.getItem("userenabledFeatures");
  if (userEnabledFeatures) {
    userEnabledFeatures = JSON.parse(userEnabledFeatures);
  }
  const handleSelectCategory = (e: any) => {
    const { value } = e.target;
    setSelectedCategory(value);
  };

  const onChangeradiocat = (event: any) => {
    setChangeradiocat(event.target.value);
  };
  // const GeneralSettingsTitleFbIcon = (type: any) => {
  //   return productParams.productParams.products[0].feedbackAgentSettings
  //     ?.feedbackSettings?.icon;
  // };

  const GeneralSettingsTitleFbIcon = (type: any) => {
    let icon = "";
    if (type == "Feedback") {
      if (
        productParams.productParams.products[0].feedbackAgentSettings
          ?.feedbackSettings?.icon
      ) {
        icon = icon =
          productParams.productParams.products[0].feedbackAgentSettings?.feedbackSettings?.icon.startsWith(
            "<svg"
          )
            ? "data:image/svg+xml;base64," +
              window.btoa(
                productParams.productParams.products[0].feedbackAgentSettings
                  ?.feedbackSettings?.icon
              )
            : productParams.productParams.products[0].feedbackAgentSettings
                ?.feedbackSettings?.icon;
      } else {
        icon = `https://${uploadFileBucketName}.s3.amazonaws.com/feedbackIcon.png`;
      }
    }
    if (type == "Bugs") {
      if (
        productParams.productParams.products[0].feedbackAgentSettings
          ?.bugSettings?.icon
      ) {
        icon =
          productParams.productParams.products[0].feedbackAgentSettings?.bugSettings?.icon.startsWith(
            "<svg"
          )
            ? "data:image/svg+xml;base64," +
              window.btoa(
                productParams.productParams.products[0].feedbackAgentSettings
                  ?.bugSettings?.icon
              )
            : productParams.productParams.products[0].feedbackAgentSettings
                ?.bugSettings?.icon;
      } else {
        icon = `https://${uploadFileBucketName}.s3.amazonaws.com/bugIcon.png`;
      }
    }
    if (type == "Freq") {
      if (
        productParams.productParams.products[0].feedbackAgentSettings
          ?.featureReqSettings?.icon
      ) {
        icon =
          productParams.productParams.products[0].feedbackAgentSettings?.featureReqSettings?.icon.startsWith(
            "<svg"
          )
            ? "data:image/svg+xml;base64," +
              window.btoa(
                productParams.productParams.products[0].feedbackAgentSettings
                  ?.featureReqSettings?.icon
              )
            : productParams.productParams.products[0].feedbackAgentSettings
                ?.featureReqSettings?.icon;
      } else {
        icon = `https://${uploadFileBucketName}.s3.amazonaws.com/featureIcon.png`;
      }
    }
    return icon;
  };

  const GeneralSettingsMainTitle = () => {
    return productParams.productParams.products[0].feedbackAgentSettings?.title;
  };
  const GeneralSettingsBannerImage = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.bannerImage;
  };
  const GeneralSettingsBannerText = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.bannerText;
  };
  const GeneralSettingsTitleFbOption = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.feedbackSettings?.title;
  };
  const GeneralSettingsTitleFbAddiotntooltip = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.feedbackSettings?.tooltip;
  };
  const GeneralSettingsTitleBugOption = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.bugSettings?.title;
  };
  const GeneralSettingsTitleBugAddiotntooltip = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.bugSettings?.tooltip;
  };
  const GeneralSettingsTitleFrOption = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.featureReqSettings?.title;
  };
  const GeneralSettingsTitleFrAddiotntooltip = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.featureReqSettings?.tooltip;
  };
  const Mainlogo = () => {
    return productParams.productParams.products[0]?.logo;
  };

  // const freqfullscreenchanged = (event: any) => {
  //   // document.fullscreenElement will point to the element that
  //   // is in fullscreen mode if there is one. If not, the value
  //   // of the property is null.
  //   if (document.fullscreenElement) {
  //     setPreviewZoom("zoomin");
  //   } else {
  //     setPreviewZoom("zoomout");
  //   }
  // };

  // const el: any = document.getElementById("genset-fullscreen-div");
  // const tt: any = document.getElementById("genset-toggle-fullscreen");

  // if (el != null) {
  //   el.addEventListener("fullscreenchange", freqfullscreenchanged);
  //   // or
  //   el.onfreqfullscreenchange = freqfullscreenchanged;
  // }

  // if (tt != null) {
  //   // When the toggle button is clicked, enter/exit fullscreen

  //   tt.addEventListener("click", (event: any) => {
  //     if (document.fullscreenElement) {
  //       // exitFullscreen is only available on the Document object.
  //       document.exitFullscreen();
  //     } else {
  //       el.requestFullscreen();
  //     }
  //   });
  // }

  // const zoomClick = () => (event: any) => {
  //   const fullscreendiv: any = document.getElementById("genset-fullscreen-div");
  //   if (document.fullscreenElement) {
  //     setPreviewZoom("zoomout");
  //     // exitFullscreen is only available on the Document object.
  //     document.exitFullscreen();
  //   } else {
  //     fullscreendiv.requestFullscreen();
  //     setPreviewZoom("zoomin");
  //   }
  // };

  const handleTogglePreview = () => {
    setPreviewAgent((prevState) => !prevState);
  };

  const renderMainTitleColor = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-title"];
  };

  const renderMainTitleFontSize = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-title-font-size"];
  };

  const renderMainTitleFontWeight = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-title-font-weight"];
  };

  const renderMainTitleFontStyle = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-title-font-style"];
  };

  const renderMainTitleFontFamily = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-title-font-family"];
  };

  const renderSubTitleColor = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-subtitle"];
  };

  const renderSubTitleFontSize = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-subtitle-font-size"];
  };

  const renderSubTitleFontWeight = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-subtitle-font-weight"];
  };

  const renderSubTitleFontStyle = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-subtitle-font-style"];
  };

  const renderSubTitleFontFamily = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-subtitle-font-family"];
  };

  const brandingCuvoPopupDialogAgentbg = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-agent-bg"];
  };

  const FbTooltipMsg = () => {
    return (
      productParams.productParams.products[0].feedbackAgentSettings?.subtitle ||
      ""
    );
  };

  const renderCardBg = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-card-bg"];
  };

  const renderCardTitle = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-card-title"];
  };

  const renderCardTitleFontSize = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-card-title-font-size"];
  };

  const renderCardTitleFontWeight = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-card-title-font-weight"];
  };

  const renderCardTitleFontStyle = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-card-title-font-style"];
  };

  const renderCardTitleFontFamily = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-card-title-font-family"];
  };

  const renderCardSubTitle = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-card-subtitle"];
  };

  const renderCardSubTitleFontSize = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-card-subtitle-font-size"];
  };

  const renderCardSubTitleFontWeight = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-card-subtitle-font-weight"];
  };

  const renderCardSubTitleFontStyle = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-card-subtitle-font-style"];
  };

  const renderCardSubTitleFontFamily = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-card-subtitle-font-family"];
  };

  const renderprimayBtnColor = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-primary-button-bg"];
  };

  const renderprimayBtnTextColor = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-primary-button-text-color"];
  };

  const renderInputLabelColor = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-input-label-color"];
  };

  function feedbackFgSvgColor() {
    // Lookup the <img> by Id
    const img: any = document.getElementById("feedbackfg");
    if (img && img.src && img.src.startsWith("<svg")) {
      // Strip "data:image/svg+xml;base64," to get encoded SVG
      const encoded = img.src.substring(26);
      // Decode base64
      const decoded = window.atob(encoded);
      // Create an HTML element from decoded SVG
      const wrapper = document.createElement("div");
      wrapper.innerHTML = decoded;
      const newSvg: any = wrapper;
      // Lookup the <path> and get a ref
      const paths: any = newSvg.getElementsByTagName("path");
      [].forEach.call(paths, function (path: any) {
        path.setAttribute(
          "fill",
          productParams.productParams.products[0].feedbackAgentSettings
            .branding["branding-cuvo-card-svg-fg-color"]
        );
      });
      const imgtag = document.querySelector("img.img1");
      if (imgtag) {
        imgtag.setAttribute(
          "src",
          "data:image/svg+xml;base64," + window.btoa(newSvg.innerHTML)
        );
      }
    }
  }
  function bugFgSvgColor() {
    // Lookup the <img> by Id
    const img: any = document.getElementById("bugfg");
    // Strip "data:image/svg+xml;base64," to get encoded SVG
    if (img && img.src && img.src.startsWith("<svg")) {
      const encoded = img.src.substring(26);

      // Decode base64
      const decoded = window.atob(encoded);
      // Create an HTML element from decoded SVG
      const wrapper = document.createElement("div");
      wrapper.innerHTML = decoded;
      const newSvg: any = wrapper;

      // Lookup the <path> and get a ref
      const paths: any = newSvg.getElementsByTagName("path");
      [].forEach.call(paths, function (path: any) {
        path.setAttribute(
          "fill",
          productParams.productParams.products[0].feedbackAgentSettings
            .branding["branding-cuvo-card-svg-fg-color"]
        );
      });

      const imgtag = document.querySelector("img.img2");
      if (imgtag) {
        imgtag.setAttribute(
          "src",
          "data:image/svg+xml;base64," + window.btoa(newSvg.innerHTML)
        );
      }
    }
  }
  function freqFgSvgColor() {
    // Lookup the <img> by Id
    const img: any = document.getElementById("freqfg");
    // Strip "data:image/svg+xml;base64," to get encoded SVG
    if (img && img.src && img.src.startsWith("<svg")) {
      const encoded = img.src.substring(26);
      // Decode base64
      const decoded = window.atob(encoded);
      // Create an HTML element from decoded SVG
      const wrapper = document.createElement("div");
      wrapper.innerHTML = decoded;
      const newSvg: any = wrapper;
      // Lookup the <path> and get a ref
      const paths: any = newSvg.getElementsByTagName("path");
      [].forEach.call(paths, function (path: any) {
        path.setAttribute(
          "fill",
          productParams.productParams.products[0].feedbackAgentSettings
            .branding["branding-cuvo-card-svg-fg-color"]
        );
      });
      const imgtag = document.querySelector("img.img3");
      if (imgtag) {
        imgtag.setAttribute(
          "src",
          "data:image/svg+xml;base64," + window.btoa(newSvg.innerHTML)
        );
      }
    }
  }
  React.useEffect(() => {
    feedbackFgSvgColor();
    bugFgSvgColor();
    freqFgSvgColor();
  }, [productParams]);
  const renderSvgBg = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-card-svg-bg-color"];
  };
  const renderCardBorderClr = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-card-border-color"];
  };
  const renderCardBorderRadius = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-card-border-radius"];
  };
  const renderEditorFontSize = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-editor-font-size"];
  };
  const renderEditorFontFamily = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-editor-font-family"];
  };

  const GeneralSettingsMenus = () => {
    appLogger.info({
      infoObj: {
        method: "GeneralSettingsMenus",
        component: "add-product",
        fileName: "GeneralSettingsAgentPreview.tsx",
        productParams: productParams,
      },
    });
    const content: any = [];
    productParams.productParams.products[0].feedbackAgentSettings?.feedbackTypes.map(
      (e: any) => {
        if (
          e == FEEDBACK_TYPE_FEEDBACK &&
          enableFeedback &&
          userEnabledFeatures.enableFeedback
        ) {
          content.push(
            <ListItem
              className="li-gen"
              sx={{
                background: renderCardBg(),
                mb: previewAgent ? "15px" : 1,
                border: "1px solid" + renderCardBorderClr(),
                borderRadius: renderCardBorderRadius(),
                padding: previewAgent ? "20px 30px!important" : "15px",
              }}
            >
              <ListItemIcon>
                <span
                  className={`${
                    previewAgent
                      ? "feedback-icons"
                      : "GeneralSettingsTitleFbIcon"
                  }`}
                  style={{ background: renderSvgBg(), borderRadius: "50%" }}
                >
                  <img
                    src={GeneralSettingsTitleFbIcon("Feedback")}
                    className="img1"
                    id="feedbackfg"
                  />
                </span>
              </ListItemIcon>
              <Typography className="font-14">
                <ListItemText
                  className="agent-gen-text"
                  // primary={GeneralSettingsTitleFbOption()}
                  primary={
                    <Typography
                      sx={{
                        color: renderCardTitle(),
                        fontSize: !previewAgent
                          ? parseInt(renderCardTitleFontSize()) / 1.2 + "px"
                          : renderCardTitleFontSize(),
                        fontWeight: renderCardTitleFontWeight(),
                        fontStyle: renderCardTitleFontStyle(),
                        fontFamily: renderCardTitleFontFamily(),
                      }}
                    >
                      {GeneralSettingsTitleFbOption()}
                    </Typography>
                  }
                  secondary={
                    <Typography
                      sx={{
                        color: renderCardSubTitle(),
                        // fontSize: renderCardSubTitleFontSize(),
                        fontSize: !previewAgent
                          ? parseInt(renderCardSubTitleFontSize()) / 1.1 + "px"
                          : renderCardSubTitleFontSize(),
                        fontWeight: renderCardSubTitleFontWeight(),
                        fontStyle: renderCardSubTitleFontStyle(),
                        fontFamily: renderCardSubTitleFontFamily(),
                      }}
                    >
                      {GeneralSettingsTitleFbAddiotntooltip()}
                    </Typography>
                  }
                />{" "}
              </Typography>
              <ListItemIcon sx={{ flexGrow: 1, justifyContent: "right" }}>
                {/* <ArrowForwardIosIcon
                  sx={{
                    color: renderCardTitle(),
                    opacity: 0.7,
                    fontSize: "40px",
                  }}
                /> */}
                {renderChevronRight({
                  color: renderCardTitle(),
                  width: previewAgent ? "18px" : "15px",
                  height: previewAgent ? "33px" : "15px",
                })}
              </ListItemIcon>
            </ListItem>
          );
        } else if (
          e == FEEDBACK_TYPE_BUGS &&
          enableBugReport &&
          userEnabledFeatures.enableBugReport
        ) {
          content.push(
            <ListItem
              className="li-gen"
              sx={{
                background: renderCardBg(),
                mb: previewAgent ? "15px" : 1,
                border: "1px solid" + renderCardBorderClr(),
                borderRadius: renderCardBorderRadius(),
                padding: previewAgent ? "20px 30px!important" : "15px",
              }}
            >
              <ListItemIcon>
                <span
                  className={`${
                    previewAgent
                      ? "feedback-icons"
                      : "GeneralSettingsTitleFbIcon"
                  }`}
                  style={{ background: renderSvgBg(), borderRadius: "50%" }}
                >
                  <img
                    src={GeneralSettingsTitleFbIcon("Bugs")}
                    className="img2"
                    id="bugfg"
                  />
                </span>
              </ListItemIcon>
              <ListItemText
                className="agent-gen-text"
                primary={
                  <Typography
                    sx={{
                      color: renderCardTitle(),
                      fontSize: !previewAgent
                        ? parseInt(renderCardTitleFontSize()) / 1.2 + "px"
                        : renderCardTitleFontSize(),
                      fontWeight: renderCardTitleFontWeight(),
                      fontStyle: renderCardTitleFontStyle(),
                      fontFamily: renderCardTitleFontFamily(),
                    }}
                  >
                    {GeneralSettingsTitleBugOption()}
                  </Typography>
                }
                secondary={
                  <Typography
                    sx={{
                      color: renderCardSubTitle(),
                      fontSize: !previewAgent
                        ? parseInt(renderCardSubTitleFontSize()) / 1.1 + "px"
                        : renderCardSubTitleFontSize(),
                      fontWeight: renderCardSubTitleFontWeight(),
                      fontStyle: renderCardSubTitleFontStyle(),
                      fontFamily: renderCardSubTitleFontFamily(),
                    }}
                  >
                    {GeneralSettingsTitleBugAddiotntooltip()}
                  </Typography>
                }
              />
              <ListItemIcon sx={{ flexGrow: 1, justifyContent: "right" }}>
                {/* <ArrowForwardIosIcon
                  sx={{
                    color: renderCardTitle(),
                    opacity: 0.7,
                    fontSize: "40px",
                  }}
                /> */}
                {renderChevronRight({
                  color: renderCardTitle(),
                  width: previewAgent ? "18px" : "15px",
                  height: previewAgent ? "33px" : "15px",
                })}
              </ListItemIcon>
            </ListItem>
          );
        } else if (
          e == FEEDBACK_TYPE_FEATURE_REQ &&
          enableFeatureRequest &&
          userEnabledFeatures.enableFeatureRequest
        ) {
          content.push(
            <ListItem
              className="li-gen"
              sx={{
                background: renderCardBg(),
                mb: previewAgent ? "15px" : 1,
                border: "1px solid" + renderCardBorderClr(),
                borderRadius: renderCardBorderRadius(),
                padding: previewAgent ? "20px 30px!important" : "15px",
              }}
            >
              <ListItemIcon>
                <span
                  className={`${
                    previewAgent
                      ? "feedback-icons"
                      : "GeneralSettingsTitleFbIcon"
                  }`}
                  style={{ background: renderSvgBg(), borderRadius: "50%" }}
                >
                  <img
                    src={GeneralSettingsTitleFbIcon("Freq")}
                    className="img3"
                    id="freqfg"
                  />
                </span>
              </ListItemIcon>
              <ListItemText
                className="agent-gen-text"
                primary={
                  <Typography
                    sx={{
                      color: renderCardTitle(),
                      // fontSize: renderCardTitleFontSize(),
                      fontSize: !previewAgent
                        ? parseInt(renderCardTitleFontSize()) / 1.2 + "px"
                        : renderCardTitleFontSize(),
                      fontWeight: renderCardTitleFontWeight(),
                      fontStyle: renderCardTitleFontStyle(),
                      fontFamily: renderCardTitleFontFamily(),
                    }}
                  >
                    {GeneralSettingsTitleFrOption()}
                  </Typography>
                }
                secondary={
                  <Typography
                    sx={{
                      color: renderCardSubTitle(),
                      fontSize: !previewAgent
                        ? parseInt(renderCardSubTitleFontSize()) / 1.1 + "px"
                        : renderCardSubTitleFontSize(),
                      fontWeight: renderCardSubTitleFontWeight(),
                      fontStyle: renderCardSubTitleFontStyle(),
                      fontFamily: renderCardSubTitleFontFamily(),
                    }}
                  >
                    {GeneralSettingsTitleFrAddiotntooltip()}
                  </Typography>
                }
              />
              <ListItemIcon sx={{ flexGrow: 1, justifyContent: "right" }}>
                {/* <ArrowForwardIosIcon
                  sx={{
                    color: renderCardTitle(),
                    opacity: 0.7,
                    fontSize: "40px",
                  }}
                /> */}
                {renderChevronRight({
                  color: renderCardTitle(),
                  width: previewAgent ? "18px" : "15px",
                  height: previewAgent ? "33px" : "15px",
                })}
              </ListItemIcon>
            </ListItem>
          );
        }
      }
    );

    return content;
  };

  return (
    <>
      <Typography ref={props.generalPreviewRef}></Typography>
      <Typography className="prev-text-titile">
        General Settings: Agent Preview &nbsp;
      </Typography>
      {!previewAgent && (
        <div>
          <Typography
            className="zoomicons guideTourFeedbackViewActualSize"
            onClick={handleTogglePreview}
            sx={{
              color: "#0157FF",
              fontSize: 12,
              textAlign: "center",
              cursor: "pointer",
            }}
          >
            Click to preview actual size
          </Typography>
        </div>
      )}
      {previewAgent && <Box className="general-settings-overlay" />}
      <div
        id="genset-fullscreen-div"
        className={`genset-fullscreen-div general-settings-container ${
          previewAgent ? "general-settings-preview" : ""
        } `}
        style={{
          height: previewAgent ? "100%" : "auto",
          marginTop: previewAgent ? "0px" : "8px",
          padding: previewAgent ? "20px 20px 20px 50px" : "16px",
          boxShadow:
            "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
          background: brandingCuvoPopupDialogAgentbg(),
        }}
      >
        <Grid
          className={PreviewZoom}
          container
          flexDirection="column"
          flexWrap="nowrap"
          sx={{
            // mt: 1,
            // p: 2,
            // border: "1px solid #dbdce0",
            // height: previewAgent ? "100%" : "auto",
            // marginTop: previewAgent ? "0px" : "8px",
            // padding: previewAgent ? "20px 20px 20px 50px" : "16px",
            // boxShadow:
            //   "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
            // background: brandingCuvoPopupDialogAgentbg(),
            height: "100%",
          }}
        >
          <button
            className={`${
              previewAgent
                ? "cuvo-popup-dialog-close"
                : "cuvo-popup-dialog-close-small"
            }`}
            style={{
              backgroundColor: renderprimayBtnColor(),
              fontSize: !previewAgent ? "13px" : "20px",
              color: renderprimayBtnTextColor(),
              border: "none",
            }}
          >
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="122.878px"
              height="122.88px"
              viewBox="0 0 122.878 122.88"
              enable-background="new 0 0 122.878 122.88"
              style={{ fill: renderprimayBtnTextColor() }}
            >
              <g>
                <path d="M1.426,8.313c-1.901-1.901-1.901-4.984,0-6.886c1.901-1.902,4.984-1.902,6.886,0l53.127,53.127l53.127-53.127 c1.901-1.902,4.984-1.902,6.887,0c1.901,1.901,1.901,4.985,0,6.886L68.324,61.439l53.128,53.128c1.901,1.901,1.901,4.984,0,6.886 c-1.902,1.902-4.985,1.902-6.887,0L61.438,68.326L8.312,121.453c-1.901,1.902-4.984,1.902-6.886,0 c-1.901-1.901-1.901-4.984,0-6.886l53.127-53.128L1.426,8.313L1.426,8.313z"></path>
              </g>
            </svg>
          </button>

          <Typography className="preview-close-icon">
            For Preview{" "}
            <span onClick={handleTogglePreview} className="prevclose">
              {" "}
              &nbsp; x &nbsp;Close&nbsp;
            </span>
          </Typography>

          <Grid
            container
            item
            xs={12}
            justifyContent="space-between"
            alignItems="baseline"
            flexBasis="unset!important"
          >
            <Box className="gen-maintitle">
              <Typography
                sx={{
                  color: renderMainTitleColor(),
                  fontSize: !previewAgent
                    ? parseInt(renderMainTitleFontSize()) / 1.9 + "px"
                    : renderMainTitleFontSize(),
                  fontStyle: renderMainTitleFontStyle(),
                  fontFamily: renderMainTitleFontFamily(),
                  fontWeight: renderMainTitleFontWeight(),
                }}
              >
                {GeneralSettingsMainTitle()}
              </Typography>
              <Typography
                style={{
                  color: renderSubTitleColor(),
                  fontSize: !previewAgent
                    ? parseInt(renderSubTitleFontSize()) / 1.9 + "px"
                    : renderSubTitleFontSize(),
                  fontStyle: renderSubTitleFontStyle(),
                  fontFamily: renderSubTitleFontFamily(),
                  fontWeight: renderSubTitleFontWeight(),
                }}
              >
                {FbTooltipMsg()}
              </Typography>
            </Box>
            {/* <Grid item xs={4} className="gen-mainlogo">
              {productParams.productParams.products[0].feedbackAgentSettings
                .showLogo && (
                <Typography sx={{ textAlign: "right" }}>
                  <img
                    style={{ width: previewAgent ? "100px" : "60px" }}
                    src={Mainlogo()}
                  />
                </Typography>
              )}
            </Grid> */}
            {productParams.productParams.products[0].feedbackAgentSettings
              .showLogo && (
              <img
                style={{ width: previewAgent ? "100px" : "60px" }}
                src={Mainlogo()}
              />
            )}
          </Grid>

          <Grid item xs={12} md={12} className="gen-listmenus">
            {productParams &&
              productParams.productParams &&
              productParams.productParams.products &&
              productParams.productParams.products[0] &&
              productParams.productParams.products[0].feedbackAgentSettings &&
              productParams.productParams.products[0].feedbackAgentSettings
                .bannerType &&
              productParams.productParams.products[0].feedbackAgentSettings
                .bannerType == TYPE_TEXT && (
                <Typography
                  className="fbtopdialogtitle"
                  dangerouslySetInnerHTML={{
                    __html: GeneralSettingsBannerText(),
                  }}
                  sx={{
                    fontSize: !previewAgent
                      ? parseInt(renderEditorFontSize()) / 1.2 + "px"
                      : renderEditorFontSize(),
                    fontFamily: renderEditorFontFamily(),
                  }}
                ></Typography>
              )}
            {productParams &&
              productParams.productParams &&
              productParams.productParams.products &&
              productParams.productParams.products[0] &&
              productParams.productParams.products[0].feedbackAgentSettings &&
              productParams.productParams.products[0].feedbackAgentSettings
                .bannerType &&
              productParams.productParams.products[0].feedbackAgentSettings
                .bannerType == TYPE_IMAGE && (
                <Typography sx={{ textAlign: "center", mt: "30px" }}>
                  <img
                    style={{
                      width: !previewAgent ? "100px" : "200px",
                    }}
                    src={GeneralSettingsBannerImage()}
                  />
                </Typography>
              )}
            <List
              sx={{
                flexGrow: 1,
                overflow: "auto",
                margin: "35px 0 25px",
                paddingRight: previewAgent ? "30px" : "12px",
              }}
            >
              {GeneralSettingsMenus()}
            </List>
          </Grid>
          <Box display="flex">
            {/* <Typography
              sx={{
                fontSize: previewAgent ? 12 : 10,
                textAlign: "center",
                width: "100%",
                color: "#c1c1c1;",
                marginTop: "auto",
              }}
            >
              <span
                style={{
                  color: renderInputLabelColor(),
                  opacity: 0.7,
                }}
              >
                Powered by
              </span>{" "}
              <b>
                <span
                  style={{
                    color: renderInputLabelColor(),
                    opacity: 0.7,
                  }}
                >
                  Cuvo
                </span>
              </b>{" "}
            </Typography> */}

            <FooterLogo
              previewAgent={previewAgent}
              renderInputLabelColor={renderInputLabelColor}
            />
          </Box>
        </Grid>
      </div>
      {/* ***********Multipage Feeback Form ********************** */}
      {/* ***********MultipageFeeback Form ********************** */}
      {productParams.productParams.products[0]?.feedbackAgentSettings
        .feedbackSettings.type == FEEDBACK_FLOW_DYNAMIC ? (
        <>
          <Typography ref={props.feedbackPreviewRef}></Typography>
          <MultiFeedbackSettingsPreview
            productParams={productParams}
            page={1}
            onChangeradiocat={onChangeradiocat}
            Changeradiocat={Changeradiocat}
            selectedCategory={selectedCategory}
            handleSelectCategory={handleSelectCategory}
          />
          <MultiFeedbackSettingsPreview
            productParams={productParams}
            page={2}
            onChangeradiocat={onChangeradiocat}
            Changeradiocat={Changeradiocat}
            selectedCategory={selectedCategory}
            handleSelectCategory={handleSelectCategory}
          />
          <MultiFeedbackSettingsPreview
            productParams={productParams}
            page={3}
            onChangeradiocat={onChangeradiocat}
            Changeradiocat={Changeradiocat}
            selectedCategory={selectedCategory}
            handleSelectCategory={handleSelectCategory}
          />
        </>
      ) : (
        <>
          <Typography ref={props.feedbackPreviewRef}></Typography>
          {enableFeedback && userEnabledFeatures?.enableFeedback && (
            <FeedbackSettingsPreview productParams={productParams} />
          )}
        </>
      )}
      {/* ***********MultipageFeeback Form ********************** */}
      {/* ***********Feeback Form ********************** */}
      {/* <Typography ref={props.feedbackPreviewRef}></Typography>
      <FeedbackSettingsPreview productParams={productParams} /> */}
      {/* ***********Feeback Form ********************** */}
      {/* ***********Bug Form ********************** */}
      <Typography ref={props.bugPreviewRef}></Typography>
      {enableBugReport && userEnabledFeatures?.enableBugReport && (
        <BugSettingsPreview productParams={productParams} />
      )}
      {/* ***********Bug Form ********************** */}
      {/* ***********Feature Request Form ********************** */}
      <Typography ref={props.featurePreviewRef}></Typography>
      {enableFeatureRequest && userEnabledFeatures?.enableFeatureRequest && (
        <FeatureRequestPreview productParams={productParams} />
      )}
      {/* ***********Feature Request Form ********************** */}
      {enableFeedback && userEnabledFeatures?.enableFeedback && (
        <MultiFeedbackSettingsPreview
          productParams={productParams}
          page={4}
          onChangeradiocat={onChangeradiocat}
          Changeradiocat={Changeradiocat}
        />
      )}
      {/* **************************Widget Preview**************************************/}
      <Typography ref={props.widgetCodePreviewRef}></Typography>
      <WidgetPreview widgetInfo={widgetInfo} productParams={productParams} />
      {/* ************************************************************************************ */}
    </>
  );
};

export default GeneralSettingsAgentPreview;
